import { BaseApiModel } from 'app/models/api/response';

export class Device extends BaseApiModel {
    deviceType = '';
    fcmToken = '';
    updatedAt = '';
}
